import React from 'react'
import './Certificate.css'
const Certificate = () => {
  return (
    <>
    <div className='container-fluid bg-shape1' id='certi'>
        <div className='row'>
        <h3 className='text-center mt-5 mb-5 hr-lines'>Crtificates Acheivement</h3>

        <div className='col-lg-1'></div>

        <div className='col-lg-4 shadow-lg p-3'>
            <div className='effect'>
        <img src='./images/certi.PNG' alt='Certificate' className='img-fluid'/>
        </div>
        <center>
        <button className='button'><span>Read More</span></button>
        </center>
        </div>



<div className='col-lg-1'></div>

<div className='col-lg-4 shadow-lg p-3'>
            <div className='effect'>
        <img src='./images/certi2.PNG' alt='Certificate' className='img-fluid'/>
        </div>
        <center>
        <button className='button'><span>Read More</span></button>
        </center>
        </div>

        </div>
    </div>
    <div className='col-lg-1'></div>
    </>
  )
}

export default Certificate